import PropTypes from 'prop-types';
import useWindowWidth from '../../../hooks/useWindowWidth';
import { useMemo } from 'react';

function IsMobile(props) {
  const { desktop, mobile, width } = props;

  const windowWidth = useWindowWidth();

  const isMobile = useMemo(() => windowWidth <= width, [windowWidth, width]);
  if (isMobile) {
    return mobile || null;
  } else {
    return desktop || null;
  }
}

export default IsMobile;

IsMobile.defaultProps = {
  mobile: null,
  desktop: null,
  width: 768,
};

IsMobile.propTypes = {
  mobile: PropTypes.element,
  width: PropTypes.number,
};
